import { Edit2, TickCircle, Timer1, Trash } from "iconsax-react";
import moment from "moment-jalaali";
import { useTranslation } from "react-i18next";
import {
    describeTarget,
    formatDiscount,
    inferTarget,
    remainingLabel,
} from "./helpers";

function clubLevelCaption(level, t) {
    if (level === 2) return t("offers.level.active");
    if (level === 3) return t("offers.level.supporter");
    return t("offers.level.normal");
}

export default function OfferTicket({
    data,
    onOpen,
    onEdit,
    onDelete,
}) {
    const { t } = useTranslation();
    const target = inferTarget(data?.sale_cart, data?.sale_cart);
    const remaining = remainingLabel(data?.remain_count, data?.discount_cards_count);
    const score = data?.requireds?.[0]?.required_score;
    const level = data?.requireds?.[0]?.club_level;

    return (
        <article className="offer-ticket">
            <div className="offer-ticket__stub" aria-hidden="true">
                <span />
                <span />
                <span />
            </div>
            <div className="offer-ticket__body">
                <header className="offer-ticket__header">
                    <span
                        className={`offer-chip offer-chip--${
                            target.kind === "itemType" ? "type" : "item"
                        }`}
                    >
                        {target.kind === "itemType"
                            ? t("offers.ticket.itemType")
                            : t("offers.ticket.item")}
                    </span>
                    <div className="offer-ticket__actions">
                        <button
                            type="button"
                            onClick={onEdit}
                            aria-label={t("offers.edit")}
                        >
                            <Edit2 size={16} aria-hidden="true" />
                        </button>
                        <button
                            type="button"
                            className="is-danger"
                            onClick={onDelete}
                            aria-label={t("offers.delete")}
                        >
                            <Trash size={16} aria-hidden="true" />
                        </button>
                    </div>
                </header>
                <button
                    type="button"
                    className="offer-ticket__open"
                    onClick={onOpen}
                >
                    <h3>{data?.name}</h3>
                    <p>{describeTarget(data?.sale_cart, t)}</p>
                    <div className="offer-ticket__metric">
                        {formatDiscount(data?.discount_amount, data?.discount_type)}
                    </div>
                    <dl>
                        <div>
                            <dt>
                                <Timer1 size={16} aria-hidden="true" />
                                {t("offers.ticket.period")}
                            </dt>
                            <dd>
                                {data?.date_start
                                    ? moment(data.date_start).format("jYYYY/jMM/jDD")
                                    : "—"}
                                <span> – </span>
                                {data?.date_end
                                    ? moment(data.date_end).format("jYYYY/jMM/jDD")
                                    : "—"}
                            </dd>
                        </div>
                        <div>
                            <dt>
                                <TickCircle size={16} aria-hidden="true" />
                                {t("offers.ticket.remaining")}
                            </dt>
                            <dd className="is-tabular">
                                {remaining.remain} {t("offers.ticket.of")}{" "}
                                {remaining.total}
                            </dd>
                        </div>
                    </dl>
                    {score != null && (
                        <p className="offer-ticket__score">
                            {t("offers.ticket.score")}: {clubLevelCaption(level, t)}{" "}
                            <strong className="is-tabular">{score}</strong>
                        </p>
                    )}
                </button>
            </div>
        </article>
    );
}
